import apiWork from './api'
import { getStandSystem } from './api/useApi'
import xbb from '@xbb/xbb-utils'

export const supportFiles = [
  'audio/mpeg',
  'audio/wav',
  'audio/mp4',
  'audio/x-ms-wma',
  'audio/aac',
  'audio/ogg',
  'application/ogg',
  'video/ogg',
  'audio/amr',
  'audio/flac',
  'audio/aiff',
  'audio/x-m4a',
  '.m4a',
  '.ogg',
  'video/mp4',
  'video/x-ms-wmv',
  'video/x-m4v',
  'video/x-flv',
  'application/vnd.rn-realmedia-vbr',
  'video/mpeg',
  'video/quicktime',
  'video/x-matroska',
  'video/webm',
  'video/x-msvideo',
  'video/mpeg',
  'video/3gpp'
]

// 将base64格式的文件转成File格式
const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

export const isH5 = getStandSystem() === 'h5'

export function isMobile() {
  return navigator.userAgent.match(
    /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
  )
}

export const ddAvatar = (function () {
  function e(e) {
    return e.match(/^([a-zA-Z]|\s|,|\.)+$/) !== null
  }

  const t = [
    '#78c06e',
    '#f65e8d',
    '#f6bf26',
    '#f65e5e',
    '#5e97f6',
    '#9a89b9',
    '#a1887f',
    '#FF8C2E',
    '#5ec9f6',
    '#3bc2b5',
    '#5c6bc0',
    '#bd84cd',
    '#6bb5ce',
    '#c5cb63',
    '#ff8e6b',
    '#78919d'
  ]
  const c = t.length
  return {
    getAvatar: function (e, t) {
      t = this._getShowName(e || t)
      const c = this._getColor(t)
      return {
        name: t,
        color: c
      }
    },
    _getShowName: function (t) {
      let c = t || ''
      c = c.replace(/[()（）【】「」{}]/g, '')
      let n = []
      if (e(c)) {
        c = c.replace(/,|\./g, ' ').replace(/\s+/g, ' ')
        n = c.split(' ')
        return n.length === 1 ? c.slice(0, 2) : n[0].slice(0, 1) + n[1].slice(0, 1)
      } else {
        return c.replace(/,|\.|\s+/g, '').slice(-2)
      }
    },
    _getColor: function (e) {
      let n = 0
      for (const char in e) n += e.charCodeAt(char)
      return t[n % c]
    }
  }
})()

/**
 * @description: 可以通过corpid判断平台 吴峰确认过
 * @param {*} corpid
 * @returns
 */
const getPlatform = (corpid = '') => {
  let currentPlat
  if (
    corpid.search('ding') === 0 ||
    corpid.indexOf('xbd$$') === 0 ||
    corpid.indexOf('xbx$$') === 0 ||
    corpid.indexOf('aid$$') === 0
  ) {
    currentPlat = 'dd'
  } else if (
    corpid.search('w') === 0 ||
    corpid.indexOf('xbw$$') === 0 ||
    corpid.indexOf('aiw$$') === 0
  ) {
    currentPlat = 'wx'
  } else if (
    corpid.search('xbb') === 0 ||
    corpid.indexOf('xbi$$') === 0 ||
    corpid.indexOf('aii$$') === 0
  ) {
    currentPlat = 'h5'
  } else {
    currentPlat = 'lark'
  }
  return currentPlat
}
/**
 * @description: 获取独立上架的 平台前缀
 * @param {*} corpid
 * @returns
 */
const getPlatformPrefix = (corpid = '', kind = 1) => {
  const currentPlat = getPlatform(corpid)
  const kindNum = +kind

  // AI 上架前缀
  const aiPrefixMap = {
    dd: 'aid$$',
    wx: 'aiw$$',
    lark: 'ail$$',
    h5: 'aii$$'
  }

  // 普通上架前缀
  const normalPrefixMap = {
    dd: kindNum === 4 ? 'xbx$$' : 'xbd$$',
    wx: 'xbw$$',
    lark: 'xbl$$',
    h5: 'xbi$$'
  }

  if (kindNum === 3) {
    return aiPrefixMap[currentPlat] || ''
  }
  return normalPrefixMap[currentPlat] || ''
}

/**
 * 移除corpid中的特定前缀。主要用于纯copid场景，例如文件上传
 * @param {string} corpid - 待处理的corpid，可能包含前缀。
 * @returns {string} 移除前缀后的corpid。
 */
const cleanCorpIdPrefix = (cid) => {
  console.log(2)
  const corpid = cid || apiWork.xbbLocalStorageGet('corpid')
  if (typeof corpid !== 'string') return corpid
  const xbPrefix = getPlatformPrefix(corpid, +apiWork.xbbLocalStorageGet('systemKind')) // xbd$$ 变成动态的 有可能是xbw$$ xbl$$
  if (!xbPrefix) return corpid
  return corpid.replace(xbPrefix, '')
}

const copyToClipboard = (text, onsuccess, onfail) => {
  try {
    if (xbb.browser() === 'Android') {
      const Context = window.plus.android.importClass('android.content.Context')
      const main = window.plus.android.runtimeMainActivity()
      const clip = main.getSystemService(Context.CLIPBOARD_SERVICE)
      window.plus.android.invoke(clip, 'setText', text)
      onsuccess()
      return
    } else if (xbb.browser() === 'ios') {
      const UIPasteboard = window.plus.ios.importClass('UIPasteboard')
      const generalPasteboard = UIPasteboard.generalPasteboard()
      // 设置/获取文本内容:
      generalPasteboard.plusCallMethod({
        setValue: text,
        forPasteboardType: 'public.utf8-plain-text'
      })
      generalPasteboard.plusCallMethod({
        valueForPasteboardType: 'public.utf8-plain-text'
      })
      onsuccess()
      return
    }
  } catch (error) {
    // 原生剪贴板不可用时，继续使用浏览器复制。
  }
  try {
    const searchParams = new URLSearchParams(window.location.search)
    const inxbbValue = searchParams.get('inxbb') || ''
    if (+inxbbValue === 1) {
      const inputEle = document.createElement('textarea')
      // 给input框赋值
      inputEle.value = text
      document.body.appendChild(inputEle)
      // 选中input框的内容
      inputEle.select()
      // 执行浏览器复制命令
      const copied = document.execCommand('Copy')
      document.body.removeChild(inputEle)
      if (copied) {
        onsuccess()
      } else {
        onfail(1)
      }
      return
    } else {
      try {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            onsuccess()
          })
          .catch(() => {
            onfail(2)
          })
      } catch (error) {
        onfail(3)
      }
    }
  } catch (error) {
    onfail(error)
  }
}

export const copyText = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text)
    return
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.style.position = 'fixed'
  textarea.style.left = '-9999px'
  textarea.style.top = '0'
  document.body.appendChild(textarea)
  textarea.focus()
  textarea.select()

  const isCopied = document.execCommand('copy')
  document.body.removeChild(textarea)

  if (!isCopied) {
    throw new Error('copy failed')
  }
}

// 延迟执行的方法
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export default {
  ...apiWork,
  isH5,
  dataURLtoFile,
  isMobile,
  ddAvatar,
  getPlatform,
  getPlatformPrefix,
  cleanCorpIdPrefix,
  copyToClipboard,
  copyText,
  delay
}
